import type { TranslationConfig } from '@bcf-v2/routes-statics/common/app/i18n-cache';
import { langRouteI18n } from '@bcf-v2/routes/common/app/i18n/lang-route-i18n';
import { playerBetsRouteI18n } from '@bcf-v2/routes/sportsbook/app/i18n/player-bets-route-i18n';

export function playerBetsRoutePath(config?: TranslationConfig): string {
  return `/${langRouteI18n(config)}/${playerBetsRouteI18n(config)}`;
}
